import { Button, tokens } from "@blurb/codex-react";
import { Box } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import React from "react";
import { Body, Heading } from "../../components/Typography";
import { useNavigateRoute } from "../../hooks/useNavigateRoute";
import { ErrorStateLayout } from "./ErrorStateLayout";

interface Error404ViewProps {
  /** Is root page. */
  root?: boolean;
}

export const Error404View: React.FC<Error404ViewProps> = ({ root = true }) => {
  const navigateRoute = useNavigateRoute();

  return (
    <ErrorStateLayout root={root} data-testid="error-404-view">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: tokens.spacing[2],
          borderRadius: tokens.radius.full,
          backgroundColor: tokens.color.semantic.bg.surfaceSunken,
        }}
      >
        <IconV3 icon="find_in_page" size={40} color={tokens.color.semantic.icon.bold} />
      </Box>
      <Heading as="h1" size="9xl" weight="medium">
        Page not found
      </Heading>
      <Body size="base">The page you’re looking for does not exist or may have been removed.</Body>
      <Button variant="filled" intent="primary" size="large" onClick={() => navigateRoute(-1)}>
        Go Back
      </Button>
    </ErrorStateLayout>
  );
};
